import {isExternal} from '@wix/wix-events-commons-statics'
import {MouseEventHandler} from 'react'
import {isFixNavigateToPageEnabled} from '../../../../../commons/selectors/experiments'
import {getEventDetailsPageUrl, getEventUrl} from '../../selectors/events'
import {AppProps} from '../app/interfaces'
import {connect} from '../runtime-context/connect'
import {LinkToPageOwnProps, LinkToPageStateProps} from './interface'
import {LinkToPage as LinkToPagePresentation} from './link-to-page'

const mapRuntime = (
  {state, actions, baseUrl, pageUrl, queryParams}: AppProps,
  {event, hasAdditionalInfoToggle, allowExternal}: LinkToPageOwnProps,
): LinkToPageStateProps => {
  const url = allowExternal
    ? getEventUrl(state, event, baseUrl, pageUrl?.relativeUrl, queryParams)
    : getEventDetailsPageUrl(state, event, baseUrl, pageUrl?.relativeUrl, queryParams)

  const fixNavigateToPageEnabled = isFixNavigateToPageEnabled(state)

  let onClick: MouseEventHandler
  if (hasAdditionalInfoToggle) {
    onClick = e => e.preventDefault()
  } else if (url) {
    onClick = e => {
      if (!fixNavigateToPageEnabled) {
        e.stopPropagation()
      }
      actions.onLinkNavigatedToPage(event)
    }
  } else {
    onClick = e => {
      e.stopPropagation()
      actions.navigateToPage(event)
    }
  }

  return {
    url,
    isExternalUrl: allowExternal && isExternal(event),
    onClick,
    disabled: hasAdditionalInfoToggle && !url,
  }
}

export const LinkToPage = connect<LinkToPageOwnProps, LinkToPageStateProps>(mapRuntime)(LinkToPagePresentation)
